import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
    en: {
        translation: {
            "Orders": "Orders",
            "Vacations": "Vacations",
            "Choose date": "Choose date",
            "Enter dates in dd.mm.yyyy format.": "Enter valid dates in dd.mm.yyyy format.",
            "Vacation dates are unavailable for orders in all offices. Both dates are included.": "Vacation dates are unavailable for orders in all offices. Both dates are included.",
            "Start date": "Start date",
            "End date (inclusive)": "End date (inclusive)",
            "Actions": "Actions",
            "Add vacation period": "Add vacation period",
            "Edit vacation period": "Edit vacation period",
            "Delete vacation period?": "Delete vacation period?",
            "Vacation period saved.": "Vacation period saved.",
            "Vacation period deleted.": "Vacation period deleted.",
            "Loading vacation periods...": "Loading vacation periods...",
            "Could not load vacation periods.": "Could not load vacation periods.",
            "Could not save the vacation period.": "Could not save the vacation period.",
            "Could not delete the vacation period.": "Could not delete the vacation period.",
            "Saved, but the list could not be refreshed. Reload the page.": "The change was saved, but the list could not be refreshed. Reload the page.",
            "No vacation periods. All dates follow the normal scheduling rules.": "No vacation periods. All dates follow the normal scheduling rules.",
            "Select both vacation dates.": "Select both vacation dates.",
            "Vacation start must not be after its end.": "Vacation start must not be after its end.",
            "Vacation periods must not overlap.": "Vacation periods must not overlap.",
            "Vacation period was not found.": "Vacation period was not found. Refresh the list.",
            "Forbidden": "You do not have permission to manage vacation periods.",
            "Retry": "Retry",
            "Saving...": "Saving...",
            "Order": "Order",
            "Order number": "Order number",
            "Description": "Description",
            "Order type": "Order type",
            "Order completion date": "Order completion date",
            "View": "View",
            "Edit": "Edit",
            "Comment": "Comment",
            "Employee": "Employee",
            "Status": "Status",
            "Save": "Save",
            "Cancel": "Cancel",
            "WAITING": "Waiting",
            "IN_PROGRESS": "In progress",
            "COMPLETED": "Completed",
            "CANCELED": "Canceled",
            "Quick order": "Quick order",
            "Complex order": "Complex order",
            "Monument": "Monument",
            "Portrait": "Portrait",
            "Add order": "Add order",
            "seller": "Seller",
            "manager": "Manager",
            "admin": "Admin",
            "Name": "Name",
            "E-mail": "E-mail",
            "Role": "Role",
            "Users": "Users",
            "Offices": "Offices",
            "Logout": "Logout",
            "Login": "Login",
            "New order": "New order",
            "Reports": "Reports",
            "Number": "Number",
            "To date": "To date",
            "Title": "Title",
            "Expired": "Expired",
            "This week": "This week",
            "No data added": "No data added",
            "No orders found...": "No orders found...",
            "Week report": "Week report",
            "Print": "Распечатать",
            "Password": "Password",
            "Password again": "Password again",
            "Add office": "Add office",
            "Code": "Code",
            "Address": "Address",
            "Sort number": "Sort number",
            "Add user": "Add user",
            "Delete": "Delete",
            "No expired orders found": "No expired orders found",
            "List": "List",
            "Grid": "Grid",
            "All offices": "All offices",
            "Other": "Other",
            "Art": "Art",
            "Visualisation": "Visual.",
            "Materials": "Materials",
            "Add material": "Add material",
            "None": "None",
            "Low": "Low",
            "Medium": "Medium",
            "High": "High",
            "Order phone": "Order phone",
            "Phone not from Latvia": "Phone not from Latvia",
            'Review link': 'Review link'
        }
    },
    ru: {
        translation: {
            "Orders": "Заказы",
            "Vacations": "Каникулы",
            "Choose date": "Выбрать дату",
            "Enter dates in dd.mm.yyyy format.": "Введите корректные даты в формате dd.mm.yyyy.",
            "Vacation dates are unavailable for orders in all offices. Both dates are included.": "Даты каникул недоступны для заказов во всех офисах. Начало и окончание включены.",
            "Start date": "Начало",
            "End date (inclusive)": "Окончание включительно",
            "Actions": "Действия",
            "Add vacation period": "Добавить период каникул",
            "Edit vacation period": "Изменить период каникул",
            "Delete vacation period?": "Удалить период каникул?",
            "Vacation period saved.": "Период каникул сохранён.",
            "Vacation period deleted.": "Период каникул удалён.",
            "Loading vacation periods...": "Загрузка периодов каникул...",
            "Could not load vacation periods.": "Не удалось загрузить периоды каникул.",
            "Could not save the vacation period.": "Не удалось сохранить период каникул.",
            "Could not delete the vacation period.": "Не удалось удалить период каникул.",
            "Saved, but the list could not be refreshed. Reload the page.": "Изменение сохранено, но список не удалось обновить. Перезагрузите страницу.",
            "No vacation periods. All dates follow the normal scheduling rules.": "Периоды каникул не заданы. Действуют обычные правила планирования.",
            "Select both vacation dates.": "Укажите обе даты каникул.",
            "Vacation start must not be after its end.": "Начало каникул не может быть позже окончания.",
            "Vacation periods must not overlap.": "Периоды каникул не должны пересекаться.",
            "Vacation period was not found.": "Период каникул не найден. Обновите список.",
            "Forbidden": "У вас нет прав для управления каникулами.",
            "Retry": "Повторить",
            "Saving...": "Сохранение...",
            "Order": "Заказ",
            "Order number": "Номер заказа",
            "Description": "Описание",
            "Order type": "Тип заказа",
            "Order completion date": "Дата сдачи заказа",
            "View": "Просмотр",
            "Edit": "Редактировать",
            "Comment": "Комментарии",
            "Employee": "Исполнитель",
            "Status": "Статус",
            "Save": "Сохранить",
            "Cancel": "Отменить",
            "WAITING": "В ожидании",
            "IN_PROGRESS": "В работе",
            "COMPLETED": "Выполнен",
            "CANCELED": "Отменен",
            "Quick order": "Быстрый заказ",
            "Complex order": "Комплексный",
            "Monument": "Памятник",
            "Portrait": "Портрет",
            "Add order": "Новый заказ",
            "seller": "Агент",
            "manager": "Менеджер",
            "admin": "Администратор",
            "Name": "Имя",
            "E-mail": "Е-маил",
            "Role": "Роль",
            "Users": "Пользователи",
            "Offices": "Бюро",
            "Logout": "Выйти",
            "Login": "Войти",
            "New order": "Новый заказ",
            "Reports": "Отчеты",
            "Number": "Номер",
            "To date": "К дате",
            "Title": "Название",
            "Expired": "Просроченный",
            "This week": "На этой неделе",
            "No data added": "Нет данных",
            "No orders found...": "Заказов не найдено...",
            "Week report": "Недельный отчет",
            "Print": "Распечатать",
            "Password": "Пароль",
            "Password again": "Пароль еще раз",
            "Add office": "Добавить бюро",
            "Code": "Код",
            "Address": "Адрес",
            "Sort number": "Сортировка",
            "Add user": "Добавить пользователя",
            "Delete": "Удалить",
            "No expired orders found": "Просроченные заказы не найдены",
            "List": "Список",
            "Grid": "Таблица",
            "All offices": "Все офисы",
            "Other": "Другое",
            "Art": "Оформ.",
            "Visualisation": "Визуал.",
            "Materials": "Материалы",
            "Add material": "Добавить материал",
            "None": "Нет",
            "Low": "Мало",
            "Medium": "Средне",
            "High": "Много",
            "Order phone": "Телефон",
            "Phone not from Latvia": "Телефон не из Латвии",
            'Review link': 'Review link'
        }
    },
    lv: {
        translation: {
            "Orders": "Pasūtījumi",
            "Vacations": "Brīvdienas",
            "Choose date": "Izvēlēties datumu",
            "Enter dates in dd.mm.yyyy format.": "Ievadiet derīgus datumus formātā dd.mm.yyyy.",
            "Vacation dates are unavailable for orders in all offices. Both dates are included.": "Brīvdienu datumi nav pieejami pasūtījumiem visos birojos. Sākuma un beigu datums ir iekļauts.",
            "Start date": "Sākuma datums",
            "End date (inclusive)": "Beigu datums (ieskaitot)",
            "Actions": "Darbības",
            "Add vacation period": "Pievienot brīvdienu periodu",
            "Edit vacation period": "Mainīt brīvdienu periodu",
            "Delete vacation period?": "Dzēst brīvdienu periodu?",
            "Vacation period saved.": "Brīvdienu periods saglabāts.",
            "Vacation period deleted.": "Brīvdienu periods dzēsts.",
            "Loading vacation periods...": "Ielādē brīvdienu periodus...",
            "Could not load vacation periods.": "Neizdevās ielādēt brīvdienu periodus.",
            "Could not save the vacation period.": "Neizdevās saglabāt brīvdienu periodu.",
            "Could not delete the vacation period.": "Neizdevās dzēst brīvdienu periodu.",
            "Saved, but the list could not be refreshed. Reload the page.": "Izmaiņas saglabātas, bet sarakstu neizdevās atjaunināt. Pārlādējiet lapu.",
            "No vacation periods. All dates follow the normal scheduling rules.": "Brīvdienu periodi nav norādīti. Ir spēkā parastie plānošanas noteikumi.",
            "Select both vacation dates.": "Norādiet abus brīvdienu datumus.",
            "Vacation start must not be after its end.": "Brīvdienu sākums nedrīkst būt pēc beigu datuma.",
            "Vacation periods must not overlap.": "Brīvdienu periodi nedrīkst pārklāties.",
            "Vacation period was not found.": "Brīvdienu periods nav atrasts. Atjauniniet sarakstu.",
            "Forbidden": "Jums nav tiesību pārvaldīt brīvdienas.",
            "Retry": "Mēģināt vēlreiz",
            "Saving...": "Saglabā...",
            "Order": "Pasūtījums",
            "Order number": "Pasūtījuma numurs",
            "Description": "Apraksts",
            "Order type": "Pasūtījuma veids",
            "Order completion date": "Pasūtījuma izgatavošanas datums",
            "View": "Apskats",
            "Edit": "Koriģēt",
            "Comment": "Komentāri",
            "Employee": "Izpildītājs",
            "Status": "Statuss",
            "Save": "Saglabāt",
            "Cancel": "Atsaukt",
            "WAITING": "Gaida",
            "IN_PROGRESS": "Aizņemts darbā",
            "COMPLETED": "Izpildīts",
            "CANCELED": "Atsaukts",
            "Quick order": "Ātrs pasūtījums",
            "Complex order": "Komplekss pasūtījums",
            "Monument": "Piemineklis",
            "Portrait": "Portrets",
            "Add order": "Jauns pasūtījums",
            "seller": "Aģents",
            "manager": "Menedžeris",
            "admin": "Administrators",
            "Name": "Vārds",
            "E-mail": "E-pasts",
            "Role": "Loma",
            "Users": "Lietotāji",
            "Offices": "Birojs",
            "Logout": "Iziet",
            "Login": "Ieiet",
            "New order": "Jauns pasūtījums",
            "Reports": "Atskaites",
            "Number": "Numurs",
            "To date": "Pie datuma",
            "Title": "Nosaukums",
            "Expired": "Nokavēts termiņš",
            "This week": "Šajā nedēļā",
            "No data added": "Nav datu",
            "No orders found...": "Pasūtījumi nav atrasti...",
            "Week report": "Nedēļas atskaite",
            "Print": "Izdrukāt",
            "Password": "Parole",
            "Password again": "Atkārtot paroli",
            "Add office": "Pievienot biroju",
            "Code": "Kods",
            "Address": "Adrese",
            "Sort number": "Šķirošana",
            "Add user": "Pievienot lietotāju",
            "Delete": "Dzēst",
            "No expired orders found": "Nokavēti pasūtījumi nav atrasti",
            "List": "Saraksts",
            "Grid": "Režģis",
            "All offices": "Visi biroji",
            "Other": "Cits",
            "Art": "Noform.",
            "Visualisation": "Visual.",
            "Materials": "Materiāli",
            "Add material": "Pievienojiet materiālu",
            "None": "Nav",
            "Low": "Mazs",
            "Medium": "Vidējas",
            "High": "Daudz",
            "Order phone": "Tālrunis",
            "Phone not from Latvia": "Telefons nav no Latvijas",
            'Review link': 'Review link'
        }
    }
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "lv", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
        // if you're using a language detector, do not define the lng option

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;
